import { defaultSteps as savingsEstimatesDefaults } from '@/components/FormBuilder/templates/SavingsEstimates/config'
import { defaultSteps as findingAssistanceDefaults } from '@/components/FormBuilder/templates/FindingAssistance/config'

export type FlowStepInputType =
  | 'text'
  | 'email'
  | 'phone'
  | 'number'
  | 'date'
  | 'select'
  | 'checkbox'
  | 'radio'
  | 'textarea'

export interface FlowStepInput {
  id: string
  label: string
  type: FlowStepInputType
  placeholder: string | null
  required: boolean
  action?: 'progress' | 'downsell'
  value?: string
}

export interface FlowStep {
  id?: number
  ordinal: number
  headline: string
  sub_headline: string
  cta_button: string
  inputs: FlowStepInput[]
}

export interface FlowBranding {
  logo: File | null
  logo_url: string | null
  logo_name: string | null
  logo_alt: string
  primary_color: string
  secondary_color: string
  accent_color: string
  cta_color: string
}

export const defaultFlowBranding: FlowBranding = {
  logo: null,
  logo_url: null,
  logo_name: null,
  logo_alt: '',
  primary_color: '#63ce4d',
  secondary_color: '#eeeeee',
  accent_color: '#1677ff',
  cta_color: '#63ce4d',
}

export interface FlowMetrics {
  cvr: string | null
  ltc: string | null
  cpa: string | null
  lead_count: number
  visitor_count: number
  growth: number
}

export interface LeadFlow {
  id: string
  name: string
  slug: string
  template_slug: string
  steps: FlowStep[]
  status: 'live' | 'draft'
  created_at: string
  updated_at: string
  chat_id: number | null
  pixel_ids: number[]
  pixels?: { id: number }[]
  downsell_id: number | null
  brand?: FlowBranding
  metrics?: FlowMetrics
}

export const mockLeadFlows: LeadFlow[] = [
  {
    id: '1',
    name: 'Flow 1',
    slug: 'flow-1',
    template_slug: 'savings-estimates',
    steps: structuredClone(savingsEstimatesDefaults),
    status: 'live',
    created_at: '2024-01-01',
    updated_at: '2024-01-01',
    chat_id: 1,
    pixel_ids: [1],
    downsell_id: 1,
    metrics: {
      cvr: '12.5',
      ltc: '3.2',
      cpa: '3',
      lead_count: 12400,
      visitor_count: 99200,
      growth: 5,
    },
  },
  {
    id: '2',
    name: 'Finding Assistance Flow',
    slug: 'finding-assistance-1',
    template_slug: 'finding-assistance',
    steps: structuredClone(findingAssistanceDefaults),
    status: 'live',
    created_at: '2024-06-15',
    updated_at: '2024-06-15',
    chat_id: 1,
    pixel_ids: [1],
    downsell_id: 1,
    metrics: {
      cvr: '10.1',
      ltc: '4.0',
      cpa: '4',
      lead_count: 8750,
      visitor_count: 86634,
      growth: -2,
    },
  },
  {
    id: '3',
    name: 'Flow 3',
    slug: 'flow-3',
    template_slug: 'savings-estimates',
    steps: structuredClone(savingsEstimatesDefaults),
    status: 'draft',
    created_at: '2024-03-10',
    updated_at: '2024-03-10',
    chat_id: 2,
    pixel_ids: [],
    downsell_id: 2,
    metrics: {
      cvr: '8.0',
      ltc: '5.0',
      cpa: '5',
      lead_count: 3200,
      visitor_count: 40000,
      growth: 0,
    },
  },
]
